const jwtServiceConfig = {
    signIn: 'public/login',
    signUp: 'api/auth/sign-up',
    accessToken: '/user/tokenIsValid',
    updateUser: 'user/update',
    renewToken: 'public/renewToken'
  };
  
  export default jwtServiceConfig;
  